import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMentorshipParticipantsByWorkspaceLocationIdQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['Int']['input'];
  workspaceLocationId: Types.Scalars['Int']['input'];
}>;


export type GetMentorshipParticipantsByWorkspaceLocationIdQuery = { __typename?: 'query_root', workspaceUsers: Array<{ __typename?: 'workspaceUsers', id: number, workspaceId: number, userId: string, user: { __typename?: 'users', id: string, fullName?: string | null, email: string, profilePhotoLink?: string | null, mentorEnabled?: boolean | null, menteeEnabled?: boolean | null, workspaceLocationId?: number | null, specialtyId?: any | null, workspaceLocation?: { __typename?: 'workspaceLocations', id: number, name: string, abbreviation?: string | null } | null, userSpecialty?: { __typename?: 'specialties', id: any, name: string } | null, mentorshipsAsMentee: Array<{ __typename?: 'mentorship', id: any, createdAt?: any | null, mentorshipProgramId?: number | null, mentorId: string, menteeId: string, mentor?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null, mentee?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null, mentorshipProgramProgresses: Array<{ __typename?: 'mentorshipProgramProgress', id: number, mentorshipProgramModuleId: number, completed: boolean }> }>, mentorshipsAsMentor: Array<{ __typename?: 'mentorship', id: any, createdAt?: any | null, mentorshipProgramId?: number | null, mentorId: string, menteeId: string, mentor?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null, mentee?: { __typename?: 'users', id: string, fullName?: string | null, profilePhotoLink?: string | null } | null, mentorshipProgramProgresses: Array<{ __typename?: 'mentorshipProgramProgress', id: number, mentorshipProgramModuleId: number, completed: boolean }> }> } }> };


export const GetMentorshipParticipantsByWorkspaceLocationIdDocument = gql`
    query getMentorshipParticipantsByWorkspaceLocationId($workspaceId: Int!, $workspaceLocationId: Int!) {
  workspaceUsers(
    where: {_and: [{workspaceId: {_eq: $workspaceId}}, {user: {workspaceLocationId: {_eq: $workspaceLocationId}}}, {user: {_or: [{mentorEnabled: {_eq: true}}, {menteeEnabled: {_eq: true}}]}}]}
  ) {
    id
    workspaceId
    userId
    user {
      id
      fullName
      email
      profilePhotoLink
      mentorEnabled
      menteeEnabled
      workspaceLocationId
      workspaceLocation {
        id
        name
        abbreviation
      }
      specialtyId
      userSpecialty {
        id
        name
      }
      mentorshipsAsMentee {
        id
        createdAt
        mentorshipProgramId
        mentorId
        mentor {
          id
          fullName
          profilePhotoLink
        }
        menteeId
        mentee {
          id
          fullName
          profilePhotoLink
        }
        mentorshipProgramProgresses {
          id
          mentorshipProgramModuleId
          completed
        }
      }
      mentorshipsAsMentor {
        id
        createdAt
        mentorshipProgramId
        mentorId
        mentor {
          id
          fullName
          profilePhotoLink
        }
        menteeId
        mentee {
          id
          fullName
          profilePhotoLink
        }
        mentorshipProgramProgresses {
          id
          mentorshipProgramModuleId
          completed
        }
      }
    }
  }
}
    `;

/**
 * __useGetMentorshipParticipantsByWorkspaceLocationIdQuery__
 *
 * To run a query within a React component, call `useGetMentorshipParticipantsByWorkspaceLocationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentorshipParticipantsByWorkspaceLocationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentorshipParticipantsByWorkspaceLocationIdQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      workspaceLocationId: // value for 'workspaceLocationId'
 *   },
 * });
 */
export function useGetMentorshipParticipantsByWorkspaceLocationIdQuery(baseOptions: Apollo.QueryHookOptions<GetMentorshipParticipantsByWorkspaceLocationIdQuery, GetMentorshipParticipantsByWorkspaceLocationIdQueryVariables> & ({ variables: GetMentorshipParticipantsByWorkspaceLocationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentorshipParticipantsByWorkspaceLocationIdQuery, GetMentorshipParticipantsByWorkspaceLocationIdQueryVariables>(GetMentorshipParticipantsByWorkspaceLocationIdDocument, options);
      }
export function useGetMentorshipParticipantsByWorkspaceLocationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentorshipParticipantsByWorkspaceLocationIdQuery, GetMentorshipParticipantsByWorkspaceLocationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentorshipParticipantsByWorkspaceLocationIdQuery, GetMentorshipParticipantsByWorkspaceLocationIdQueryVariables>(GetMentorshipParticipantsByWorkspaceLocationIdDocument, options);
        }
export function useGetMentorshipParticipantsByWorkspaceLocationIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMentorshipParticipantsByWorkspaceLocationIdQuery, GetMentorshipParticipantsByWorkspaceLocationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMentorshipParticipantsByWorkspaceLocationIdQuery, GetMentorshipParticipantsByWorkspaceLocationIdQueryVariables>(GetMentorshipParticipantsByWorkspaceLocationIdDocument, options);
        }
export type GetMentorshipParticipantsByWorkspaceLocationIdQueryHookResult = ReturnType<typeof useGetMentorshipParticipantsByWorkspaceLocationIdQuery>;
export type GetMentorshipParticipantsByWorkspaceLocationIdLazyQueryHookResult = ReturnType<typeof useGetMentorshipParticipantsByWorkspaceLocationIdLazyQuery>;
export type GetMentorshipParticipantsByWorkspaceLocationIdSuspenseQueryHookResult = ReturnType<typeof useGetMentorshipParticipantsByWorkspaceLocationIdSuspenseQuery>;
export type GetMentorshipParticipantsByWorkspaceLocationIdQueryResult = Apollo.QueryResult<GetMentorshipParticipantsByWorkspaceLocationIdQuery, GetMentorshipParticipantsByWorkspaceLocationIdQueryVariables>;